import type { AxiosError } from 'axios';
import type { HeadersParams } from '../http-client.types.ts';
import { tryRefreshAndRetry } from '../utils/api.domain.ts';
import { clearAuthData } from '../utils/auth.functions.ts';
import { isTokenInvalid, redirectToRoot } from '../utils/refresh.functions.ts';

export const handleUnauthorized = async (error: AxiosError) => {
  const headers = error.config?.headers as HeadersParams;

  if (isTokenInvalid(error)) {
    clearAuthData();
    redirectToRoot();
    throw error;
  }

  return tryRefreshAndRetry({
    callbackError: () => Promise.reject(error),
    config: error.config ?? {},
    originalError: error,
    headers
  });
};
